import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function OneColumnLayoutIcon() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5808_7157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "3",
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "3",
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "39",
    height: "39",
    rx: "2.5",
    stroke: "var(--ds-border, #091E42)",
    strokeOpacity: "0.14"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "6",
    width: "28",
    height: "1",
    rx: "0.5",
    fill: iconThemed({
      light: '#A5ADBA',
      dark: '#738496'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "10",
    width: "28",
    height: "1",
    rx: "0.5",
    fill: iconThemed({
      light: '#A5ADBA',
      dark: '#738496'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "29",
    width: "28",
    height: "1",
    rx: "0.5",
    fill: iconThemed({
      light: '#A5ADBA',
      dark: '#738496'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "33",
    width: "16",
    height: "1",
    rx: "0.5",
    fill: iconThemed({
      light: '#A5ADBA',
      dark: '#738496'
    })
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6.25",
    y: "14.25",
    width: "5",
    height: "11.5",
    rx: "0.75",
    fill: iconThemed({
      light: '#DEEBFF',
      dark: '#09326C'
    }),
    stroke: iconThemed({
      light: '#4C9AFF',
      dark: '#0C66E4'
    }),
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "13.75",
    y: "14.25",
    width: "5",
    height: "11.5",
    rx: "0.75",
    fill: iconThemed({
      light: '#DEEBFF',
      dark: '#09326C'
    }),
    stroke: iconThemed({
      light: '#4C9AFF',
      dark: '#0C66E4'
    }),
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "21.25",
    y: "14.25",
    width: "5",
    height: "11.5",
    rx: "0.75",
    fill: iconThemed({
      light: '#DEEBFF',
      dark: '#09326C'
    }),
    stroke: iconThemed({
      light: '#4C9AFF',
      dark: '#0C66E4'
    }),
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "28.75",
    y: "14.25",
    width: "5",
    height: "11.5",
    rx: "0.75",
    fill: iconThemed({
      light: '#DEEBFF',
      dark: '#09326C'
    }),
    stroke: iconThemed({
      light: '#4C9AFF',
      dark: '#0C66E4'
    }),
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5808_7157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "40",
    height: "40",
    rx: "3",
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    })
  }))));
}